require('../../modules/es.string.iterator');
require('../../modules/es.array.from');

module.exports = require('../../internals/path').Array.from;
